import { SET_IS_OPEN_PERIODS_SETTINGS_MODAL } from '../actionTypes';
import { actions } from '../reducer';

export default (isOpen) => actions[SET_IS_OPEN_PERIODS_SETTINGS_MODAL](isOpen);
